import { render, staticRenderFns } from "./advTaskStatistical.vue?vue&type=template&id=960e1b00&scoped=true&"
import script from "./advTaskStatistical.vue?vue&type=script&lang=js&"
export * from "./advTaskStatistical.vue?vue&type=script&lang=js&"
import style0 from "./advTaskStatistical.vue?vue&type=style&index=0&id=960e1b00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "960e1b00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('960e1b00')) {
      api.createRecord('960e1b00', component.options)
    } else {
      api.reload('960e1b00', component.options)
    }
    module.hot.accept("./advTaskStatistical.vue?vue&type=template&id=960e1b00&scoped=true&", function () {
      api.rerender('960e1b00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/advTaskStatistical.vue"
export default component.exports